/** @format */

import template from './gb-add-total-raised-widget.html';

export const GbAddTotalRaisedWidgetComponent = {
    template,
    require: {
        gbPresenter: '^^',
    },
    bindings: {
        widget: '=',
    },
    controller: class GbAddTotalRaisedWidgetComponent {
        constructor($gbTotalRaisedProjectorWidget, $translate) {
            'ngInject';

            this.$gbTotalRaisedProjectorWidget = $gbTotalRaisedProjectorWidget;
            this.$translate = $translate;
        }

        addWidget() {
            let widget = new this.$gbTotalRaisedProjectorWidget({
                x: 50,
                y: 50,
                x_unit: '%',
                y_unit: '%',
                width: null,
                width_unit: '%',
                height: null,
                height_unit: '%',
                opacity: 1,
                font_size: 30,
            });

            this.gbPresenter.tempWidgets.push(widget);
        }
    },
};
